import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';

import { NgZone } from '@angular/core';
import {defined,consts} from './appDefs';
import {SettingsRec} from './settings/SettingsRec';
import { InAppPurchase2} from '@ionic-native/in-app-purchase-2/ngx';

import { Capacitor } from '@capacitor/core';
import { Device,DeviceInfo} from '@capacitor/device';
import {App,AppInfo} from '@capacitor/app';
import { publishFacade } from '@angular/compiler';
import {Event,Events} from './Events.service';
import { Preferences  as Storage } from '@capacitor/preferences';
import { HttpClient } from '@angular/common/http';
import { Preferences } from '@capacitor/preferences';
import { Network } from '@capacitor/network';

declare var window :any;
export enum UsageTypes{

  DOUBLEPIANO='DoublePiano',
  KEYBROLI="Keyboard",
  UBOARD='FlexUBoard',
  GRIDBOARD='FlexGrid',

}

export class Suggest
{
  constructor(public UsageList:any[])
  {

  };


  boardScore(input:any[])
  {
    let count=0;
    let period=0;

    let session=0;
    let minDate,maxDate=0;
   input.forEach((a)=>
    {
      if (a.count)
        count+=a.count;
        if (a.time)
        {
          period+=a.time;
        }
        if (a.sessionEnd)
        {
          session++;
        }
        if (a.date < minDate)
        {
          minDate=a.date;
        }
        if (a.date > maxDate)
        {
          maxDate=a.date;
        }

    });

    return ({
     count:count,
     period:period,
     session:session,
     minDate:minDate,
     maxDate:maxDate
     
    })
  }

}

export class Usage 
  {
    label:string;
    song:string;
    time:number;
    count:number;
    date:number;
    sessionEnd:boolean;

    toRec()
    {
        return {
            label:this.label,
            song:this.song,
            time:this.time,
            count:this.count,
            date:this.date,
            sessionEnd:this.sessionEnd
        }
    }
  }
  @Injectable({
    providedIn: 'root'
  })
  export class UsageService 
  {
  usageList:any[]=[];
  constructor()
  {
    this.initUsage();

  }
  initUsage()
  {
    Preferences.get({key:'USAGE'}).then((d )=>
    {
      if (d && d.value)
      this.usageList=JSON.parse(d.value);

    });

    Preferences.get({key:'REVIEW_METRIC'})
    .then ((d)=>{
      if (d && d.value)
      this.reviewState=JSON.parse(d.value);

    });

    Preferences.get({key:'SHARE_METRIC'})
    .then ((d)=>{
      if (d && d.value)
      this.shareState=JSON.parse(d.value);

    });


  }
  logUsage(usage:Usage)
  {
this.usageList.push(usage.toRec());
Preferences.set({key:'USAGE',value:JSON.stringify(this.usageList)})
  }

  score()
  {
    let suggest=new Suggest(this.usageList);
    return (suggest.boardScore(this.usageList));


  }

  reviewState=
  {
lastShown:0,
reviewd:false,
lastUsageCount:0,


  }
  purchaseState={
purchased:false,
lastUsageCount:0,
lastShown:0
  };

  shareState={
    lastShown:0,
    shared:false,
    lastUsageCount:0,
  };

  REVIEW_THRESHOLD=500;
  REVIEW_THRESHOLD_INC=500;
  showReview()
  {
    if (!this.reviewState.reviewd)
    {
      let score=this.score();
      if (score.count > this.REVIEW_THRESHOLD)
      {
        if ((score.count - this.reviewState.lastUsageCount)
        >this.REVIEW_THRESHOLD/10)
        {
          return true;
        }

      }
    }
    return false;

  }

  reviewShown(reviewed?:boolean)
  {
    let score=this.score();
    this.reviewState.lastUsageCount=score.count;
    this.reviewState.lastShown=Date.now();
   if (reviewed) this.reviewState.reviewd=reviewed;
   Preferences.set({key:'REVIEW_METRIC',value:JSON.stringify(this.reviewState)})

  }

  SHARE_THRESHOLD=700;

  showShare()
  {
    if (!this.shareState.shared)
    {
      let score=this.score();
      if (score.count > this.SHARE_THRESHOLD)
      {
        if ((score.count - this.shareState.lastUsageCount)
        >this.SHARE_THRESHOLD/10)
        {
          return true;
        }

      }
    }
    return false;

  }

  sharedShown(shared?:boolean)
  {
    let score=this.score();
    this.shareState.lastUsageCount=score.count;
    this.shareState.lastShown=Date.now();
   if (shared) this.shareState.shared=shared;

  Preferences.set({key:'SHARE_METRIC',value:JSON.stringify(this.shareState)})

  }
  }